const MOBILE_VIEW_BREAKPOINT = 768;
export { MOBILE_VIEW_BREAKPOINT };